import { useMemo } from "react";
import { TOUR_STEPS } from "./BoardTour.ViewModel";

export interface BoardTourStepText {
  title: string;
  body: string;
}

export interface BoardTourText {
  nextText: string;
  backText: string;
  skipText: string;
  doneText: string;
  stepCounterText: (current: number, total: number) => string;
  demoCardTitle: string;
  demoCardBadgeText: string;
  steps: BoardTourStepText[];
}

export const useBoardTourText = (
  t: (key: string, opts?: Record<string, unknown>) => string,
): BoardTourText =>
  useMemo(
    () => ({
      nextText: t("tour.actions.next"),
      backText: t("tour.actions.back"),
      skipText: t("tour.actions.skip"),
      doneText: t("tour.actions.done"),
      stepCounterText: (current: number, total: number) =>
        t("tour.actions.stepCounter", { current, total }),
      demoCardTitle: t("tour.demoCard.title"),
      demoCardBadgeText: t("tour.demoCard.badge"),
      steps: TOUR_STEPS.map((step) => ({
        title: t(step.titleKey),
        body: t(step.bodyKey),
      })),
    }),
    [t],
  );
